import cn from 'bem-cn';

import { List, Stack } from '../../../UI';

import { ChallengeRequirement } from './ChallengeRequirement';
import { ChallengeRequirementBadge } from './ChallengeRequirementBadge';
import { ChallengeRequirementsProps } from './ChallengeRequirements.types';
import './ChallengeRequirements.scss';

const b = cn('challenge-requirements');

const renderRequirement = (item: string) => <ChallengeRequirement text={item} />;
const extractTagKey = (_: string, index: number) => `requirement-${index}`;

export const ChallengeRequirements = (props: ChallengeRequirementsProps) => {
    const { requirements } = props;

    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Требования к проекту</h2>
            <Stack className={b('list-container')}>
                <List
                    className={b('list')}
                    items={requirements}
                    renderItem={renderRequirement}
                    keyExtractor={extractTagKey}
                />
                <ChallengeRequirementBadge />
            </Stack>
        </Stack>
    );
};
